import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const commentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getComments: query({
        query: (videoId) => `/comments/${videoId}`,
        providesTags: (result, error, videoId) =>
          result
            ? [
                { type: "Comment", id: "LIST" },
                ...result.map(({ _id }) => ({ type: "Comment", id: _id })),
              ]
            : ["Comment"],
        meta: { requiresAuth: false },
      }),

      addComment: mutation({
        query: (body) => ({
          url: "/comments",
          method: "POST",
          body,
        }),
        invalidatesTags: (result, error, { videoId }) => [
          { type: "Comment", id: "LIST" },
          { type: "Comment", id: videoId },
        ],
      }),

      updateComment: mutation({
        query: ({ commentId, text }) => ({
          url: `/comments/${commentId}`,
          method: "PUT",
          body: { text },
        }),
        invalidatesTags: (result, error, { commentId }) => [
          { type: "Comment", id: commentId },
        ],
      }),

      deleteComment: mutation({
        query: (commentId) => ({
          url: `/comments/${commentId}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, commentId) => [
          { type: "Comment", id: "LIST" },
          { type: "Comment", id: commentId },
        ],
      }),
    };
  },
});

export const {
  useGetCommentsQuery,
  useAddCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
} = commentsApiSlice;
